<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">Contents</a></p><a id="page_v">
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="17%"/>
<col width="83%"/>
</colgroup><tbody><tr>
<td valign="top">
</td><td valign="top"><p class="tocb"><a href="#/xhtml/07_Acknowledgements">Acknowledgements</a></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toc"><a href="#/xhtml/08_Introduction#int">Introduction</a></p>
<p class="tocb"><i>Philip Hayward</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a href="#/xhtml/09_Chapter01">Chapter 1</a></p></td>
<td valign="top"><p class="toc"><a href="#/xhtml/09_Chapter01">The Middle Eastern Mermaid: Between Myth and Religion</a></p>
<p class="tocb"><i>Manal Shalaby</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample">Chapter 2</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/10_Chapter02" title="Link target outside of Sample"><i>Matsya</i> Fabulism: Hindu mythologies, Mermaids and syncretism in India and Thailand</span></p>
<p class="tocb"><i>Philip Hayward</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">Chapter 3</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample">Japan: The Mermaidisation of the <i>Ningyo</i></span></p>
<p class="tocb"><i>Philip Hayward</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample">Chapter 4</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample"><i>Legend of the Blue Sea</i>: Mermaids in South Korean folklore and popular culture</span></p>
<p class="tocb"><i>Sarah Keith and Sung-Ae Lee</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample">Chapter 5</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/13_Chapter05" title="Link target outside of Sample">From Dugongs to <i>Sinetrons</i>: Syncretic Mermaids in Indonesian Culture</span></p>
<p class="tocb"><i>Philip Hayward</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/14_Chapter06" title="Link target outside of Sample">Chapter 6</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/14_Chapter06" title="Link target outside of Sample">Changelings, Conformity and Difference: <i>Dysebel</i> and the Sirena in Filipino Popular Culture</span></p>
<p class="tocb"><i>Philip Hayward</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/15_Chapter07" title="Link target outside of Sample">Chapter 7</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/15_Chapter07" title="Link target outside of Sample">Millennial <i>Měirényú</i>: Mermaids in 21<sup>st</sup> Century Chinese Culture</span></p>
<p class="tocb"><i>Philip Hayward and Pan Wang</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/16_Chapter08" title="Link target outside of Sample">Chapter 8</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/16_Chapter08" title="Link target outside of Sample">Song of the <i>Sirenas</i>: Mermaids in Latin America and the Caribbean</span></p>
<p class="tocb"><i>Persephone Braham</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><a id="page_vi"></a><span href="#/xhtml/17_Chapter09" title="Link target outside of Sample">Chapter 9</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/17_Chapter09" title="Link target outside of Sample">Swimming Ashore: Mermaids in Australian public culture</span></p>
<p class="tocb"><i>Philip Hayward</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/18_Chapter10" title="Link target outside of Sample">Chapter 10</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/18_Chapter10" title="Link target outside of Sample">Mama Wata Remixed: The Mermaid in Contemporary African-American Culture</span></p>
<p class="tocb"><i>Nettrice R. Gaskins</i></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/xhtml/19_Chapter11" title="Link target outside of Sample">Chapter 11</span></p></td>
<td valign="top"><p class="toc"><span href="#/xhtml/19_Chapter11" title="Link target outside of Sample">Shoreline Revels: Perversity, Polyvalence and Exhibitionism at Coney Island’s Mermaid Parade</span></p>
<p class="tocb"><i>Philip Hayward and Lisa Milner</i></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="tocb"><span href="#/xhtml/20_Bibliography" title="Link target outside of Sample">Bibliography</span></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="tocb"><span href="#/xhtml/21_Bm01" title="Link target outside of Sample">Chronological catalogue of audiovisual productions featuring mermaids and mermen referenced in the volume</span></p></td>
</tr>
<tr>
<td valign="top">
</td><td valign="top"><p class="toc"><span href="#/xhtml/22_Index01" title="Link target outside of Sample">Index</span></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?177268ba